<template>
  <el-card shadow="never" class="aui-card--fill">
    <StoreList productType="产品" ref="storeList">
      <template slot="btns">
        <el-button type="primary" size="mini" @click="showCheckInDialog"
          >成品入库</el-button
        >
        <el-button type="warning" size="mini" @click="showCheckOutDialog"
          >成品出库</el-button
        >
      </template>
    </StoreList>
    <StoreLog ref="storeLog" @refreshDataList="getDataList"></StoreLog>
    <common-upload
      ref="uploader"
      @success="uploadSuccessHandler"
      uploadUrl="/trade/factorystore/import/sale"
      templateUrl="/static/template/零售发货导入模板.xlsx"
      placeHolder=""
      title="零售发货导入"
    ></common-upload>
  </el-card>
</template>

<script>
import StoreLog from "./store-log/save";
import StoreList from "./common/index";
export default {
  components: {
    StoreList,
    StoreLog,
  },
  methods: {
    //显示通用导入弹窗
    showCommonDialog() {
      this.$refs.uploader.init();
    },
    uploadSuccessHandler() {
      this.getDataList();
    },
    getDataList() {
      this.$refs.storeList.getDataList();
    },
    showCheckInDialog() {
      this.$refs.storeLog.productType = "产品";
      this.$refs.storeLog.title = "成品入库";
      this.$refs.storeLog.storeType = 1;
      this.$refs.storeLog.init();
    },
    showCheckOutDialog() {
      this.$refs.storeLog.productType = "产品";
      this.$refs.storeLog.title = "成品出库";
      this.$refs.storeLog.storeType = -1;
      this.$refs.storeLog.init();
    },
  },
};
</script>
